import React from 'react';
import { useAuthStore } from 'src/store/auth';

export const WelcomeSection = () => {
  const { user, logout } = useAuthStore();
  const displayName = user?.firstName || user?.username || 'user';

  return (
    <section className="bg-primary w-full rounded-3xl px-10 max-xs:px-5 py-10 max-1xl:py-7 max-1xl:px-9 max-md:h-60 max-md:rounded-2xl max-md:py-13 max-m:h-55 max-sm:h-47 max-sm:py-10">
      <div className="text-white">
        <p className="text-4xl tracking-wider text-profile-wellcome">Welcome {displayName}!</p>
        <h1 className="text-[80px] max-1xl:text-[70px] font-bold leading-normal -mt-2 max-md:-mt-0 max-lg:text-[9vw] max-m:text-[8vw] -mb-2">
          My Health Portal
        </h1>
      </div>
    </section>
  );
};
